import React from 'react'
import BackArrowIcon from 'assets/svg/BackArrow'
import { ReactComponent as ErrorCross } from 'assets/svg/ErrorCross.svg'
import { Drawers, OperationType } from 'store/drawer/types'
import wrapper from 'components/organisms/Drawers/wrapper'
import {
  Drawer as DrawerStyled,
  Container,
  Header,
  BackButton,
  Title,
  Content,
  IconContainer,
  ErrorTitle,
  Message,
  LinkButton,
  ActionButton
} from './styles'
import { useAppSelector } from 'hooks/redux'
import useNavigation from 'hooks/useNavigation'

interface DrawerDebinOperationErrorProps {
  showDrawer: boolean
  onClose: () => void
}

const DrawerDebinOperationError: React.FC<DrawerDebinOperationErrorProps> = ({
  showDrawer,
  onClose
}) => {
  const { onNavigate } = useNavigation()
  const { data } = useAppSelector(state => state.drawer)
  const drawerData = data[Drawers.DEBIN_OPERATION_ERROR]
  const operationType = drawerData?.debinData?.operationType
  const isAccepted = drawerData?.debinData?.isAccepted

  const acceptation = isAccepted ? 'aceptar' : 'rechazar'

  const handleVolverInicio = () => {
    onClose()
    onNavigate('/content/wallet')
  }

  return (
    <DrawerStyled open={showDrawer} onClose={onClose} direction="right">
      <Container>
        <Header>
          <BackButton type="button" onClick={onClose}>
            <BackArrowIcon />
          </BackButton>
          <Title>Pago DEBIN</Title>
        </Header>

        <Content>
          <IconContainer>
            <ErrorCross />
          </IconContainer>

          <ErrorTitle>Ocurrió un error.</ErrorTitle>

          <Message>
            {`No pudimos ${
              operationType === OperationType.DEBIN_CONFIRMATION
                ? acceptation
                : 'cancelar'
            } el DEBIN. Por favor, volvé a intentarlo.`}
          </Message>

          <LinkButton onClick={handleVolverInicio}>
            Volver a inicio
          </LinkButton>

          <ActionButton onClick={onClose}>
            Ir a Pago con DEBIN
          </ActionButton>
        </Content>
      </Container>
    </DrawerStyled>
  )
}

export default wrapper(DrawerDebinOperationError, Drawers.DEBIN_OPERATION_ERROR)
